// Jobs whose outcome the user has already been told about — so a reload never announces the same job twice.
// localStorage is a per-browser convenience, never the source of truth: every access can throw (private window,
// blocked site data) and the app must behave without it, so each one is wrapped.
const KEY = "miro_notified_jobs";
const MAX_IDS = 50;

export const readNotifiedJobs = (): string[] => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KEY) ?? "[]");

    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === "string") : [];
  } catch {
    return [];
  }
};

export const wasJobNotified = (jobId: string): boolean => readNotifiedJobs().includes(jobId);

export const markJobNotified = (jobId: string): void => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify([jobId, ...readNotifiedJobs().filter((id) => id !== jobId)].slice(0, MAX_IDS)));
  } catch {
    // Not persisting only means a reload may announce the job again.
  }
};
